import { lazy } from 'react'

const WorkScope = lazy(() => import('./WorkScope/WorkScope'))


const routes = [
    { component: WorkScope, route: '/workscope' }
]

export default routes